import store from "../../../state/store";
import { httpRequest } from "../../../services/http";
import {
  BadRequestError,
  ClinvarApiError,
  ClinvarFormError,
  ClinvarTokenError,
  NotFoundError,
  ServerNetworkError,
} from "./clinvar-error-classes";
import { submissionUrl, tokenUrl } from "../urls/urls";
import { handleSearchErrors } from "../../../common/helpers/requests";

const handleError = (err) => {
  const userErrorMessage = `An error occurred.\nIf the problem persists, contact us.`;
  const errorResText = err.response.data;
  const errorResDetail =
    typeof errorResText.detail === "object"
      ? JSON.stringify(errorResText.detail)
      : errorResText.detail;
  const errorResStatusCode = errorResText.error_status;
  if (errorResStatusCode === 10000) {
    throw new ClinvarTokenError(errorResDetail);
  }
  if (errorResStatusCode === 10001) {
    const errorDetail = errorResDetail.replace(/\\/g, " ");
    const errDetail = errorDetail.replace(/"/g, " ");
    throw new ClinvarFormError(errDetail);
  }
  if (errorResStatusCode === 10002) {
    throw new ClinvarApiError(errorResDetail);
  }
  throw new Error(errorResDetail || userErrorMessage);
};

const handleErrorStatus = (err) => {
  const { status, data } = err.response;
  const userErrorMessage = `An error occurred.\nIf the problem persists, contact us.`;
  if (status === 400) {
    if (data) {
      handleError(err);
    } else {
      throw new BadRequestError(err, "Bad request.");
    }
  }

  if (status === 402) {
    handleSearchErrors(err);
  }

  if (status === 404) {
    if (data) {
      handleError(err);
    } else {
      throw new NotFoundError(err, "The requested URL was not found.");
    }
  }

  if (status >= 500) {
    if (data) {
      handleError(err);
    } else {
      throw new ServerNetworkError(err, userErrorMessage);
    }
  }

  throw new Error(`Unknown Server Error: ${err?.message || userErrorMessage}`);
};

/* Enpoint used to retrieved a stored submission. */
export const getClinvarSubBySubmissionId = ({ submissionId }) => {
  return httpRequest
    .get(`${submissionUrl}/${submissionId}/`)
    .then((response) => response.data);
};

/* Enpoint used to update an existing submission. */
export const updateClinvarSubBySubmissionId = (submissionId, formData) => {
  return httpRequest
    .put(`${submissionUrl}/${submissionId}/`, formData)
    .then((res) => res.data)
    .catch((e) => handleErrorStatus(e));
};

/* Endpoint used to add a new submission. */
export const submitToClinvarUsingSubmissionId = (formData = {}) => {
  return httpRequest
    .post(submissionUrl, formData)
    .catch((e) => handleErrorStatus(e));
};

/* Endpoint used to retrieve all user's submissions. */
export const getUserClinvarSubmissions = () => {
  return httpRequest.get(submissionUrl).catch((e) => handleErrorStatus(e));
};

/* Endpoint used to save ClinVar token. */
export const saveClinvarToken = (token) => {
  return httpRequest
    .post(tokenUrl, { token })
    .catch((e) => handleErrorStatus(e));
};

/* Endpoint used to update ClinVar token. */
export const updateClinvarToken = (token, hashedToken) => {
  return httpRequest
    .put(`${tokenUrl}${hashedToken}/`, { token })
    .catch((e) => handleErrorStatus(e));
};

export const getTokenInfo = () => {
  return httpRequest.get(tokenUrl).catch((e) => handleErrorStatus(e));
};

export const getUser = () => {
  const url = `${store.getState().ssoUrl}/remote/auth/user/`;
  return httpRequest.get(url).catch((e) => handleErrorStatus(e));
};
